<template>
  <form method="POST" :action="action" target="_blank">
    <template v-for="field in fields">
      <input :key="field.name" type="hidden" :name="field.name" :value="field.value" />
    </template>

    <c-button
      :icon="{
        icon: 'google',
        color: 'green',
      }"
      type="submit"
      size="small"
      label="Выгрузить в Google таблицы"
      responsive
    />
  </form>
</template>

<script>
import CButton from "@/components/controls/button";

export default {
  components: { CButton },
  props: ["sp"],

  computed: {
    action() {
      const { sp } = this;

      const params = {
        r: "google-sheets/create",
        user_id: this.$store.state.userId,
        table: "debt_balance",
      };

      if (sp.sort_by) {
        params.sort_by = sp.sort_by;
        params.sort_type = sp.sort_type;
      }

      const search = Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      return `/index.php?${search}`;
    },

    fields() {
      const fields = [];

      if (this.sp.filters) {
        Object.entries(this.sp.filters).forEach(([filterName, filterValue]) => {
          Object.entries(filterValue).forEach(([fName, fData]) => {
            fields.push({
              name: `filters[${filterName}][${fName}]`,
              value: fData,
            });
          });
        });
      }

      if (this.sp.columnFilters) {
        Object.entries(this.sp.columnFilters).forEach(([columnName, columnValue]) => {
          Object.entries(columnValue).forEach(([fName, fData]) => {
            fields.push({
              name: `col_filters[${columnName}][${fName}]`,
              value: fData,
            });
          });
        });
      }

      return fields;
    },
  },
};
</script>
